import PropTypes from "prop-types"
import FavoriteCellRenderer from "../FavoriteCellRenderer"

// api
import { usePostFavoriteRequest } from "api/hooks/requests/requestFavoritesApis"

// context
import useAppState from "context/hooks/useAppState"

const FavoriteRequestCellRenderer = ({ value, data }) => {
  // Requests page uses "id"; Comments Report "Request" type uses "req_id"
  const postRequestFavorite = usePostFavoriteRequest(data?.id || data?.req_id)
  const { emitRequestFaveUpdated } = useAppState()

  return (
    <FavoriteCellRenderer
      value={value}
      onClick={() => {
        postRequestFavorite(
          {},
          {
            onSuccess: () => {
              emitRequestFaveUpdated()
            },
          }
        )
      }}
    />
  )
}

FavoriteRequestCellRenderer.propTypes = {
  value: PropTypes.bool,
  data: PropTypes.shape({
    id: PropTypes.number,
  }),
}

export default FavoriteRequestCellRenderer
